
export const HolidayEnum = Object.freeze({
    base: "base",
    halloween: "halloween",
})